var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { classNames, renderIcon } from '../../../utils';
import * as styles from './form-input.style';
import CurrencyInput from 'react-currency-input-field';
export var FormInput = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, nameProp = _a.nameProp, maxCharacters = _a.maxCharacters, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.textInputType, textInputType = _c === void 0 ? 'input' : _c, error = _a.error, _d = _a.disabled, disabled = _d === void 0 ? false : _d, suffixIcon = _a.suffixIcon, _e = _a.visible, visible = _e === void 0 ? true : _e, className = _a.className, placeholder = _a.placeholder, _f = _a.sufficIconColor, sufficIconColor = _f === void 0 ? 'black' : _f, suffixIconAction = _a.suffixIconAction, register = _a.register, onKeyDown = _a.onKeyDown, value = _a.value, hint = _a.hint, maxLength = _a.maxLength, prefixIcon = _a.prefixIcon, startIcon = _a.startIcon, startIconColor = _a.startIconColor, color = _a.color, isAdminPortalField = _a.isAdminPortalField, readonly = _a.readonly, isAdminPortalInput = _a.isAdminPortalInput, restProps = __rest(_a, ["label", "subLabel", "nameProp", "maxCharacters", "type", "textInputType", "error", "disabled", "suffixIcon", "visible", "className", "placeholder", "sufficIconColor", "suffixIconAction", "register", "onKeyDown", "value", "hint", "maxLength", "prefixIcon", "startIcon", "startIconColor", "color", "isAdminPortalField", "readonly", "isAdminPortalInput"]);
    var getInputStyle = function () {
        if (readonly) {
            return styles.readonlyInputStyle;
        }
        if (error) {
            return styles.errorStyle;
        }
        if (disabled) {
            if (isAdminPortalField) {
                return styles.portalDisabledInputStyle;
            }
            return styles.disabledInputStyle;
        }
        if (isAdminPortalField) {
            return styles.portalDdefaultInputStyle;
        }
        if (isAdminPortalInput) {
            return styles.adminPortalInputStyle;
        }
        return styles.defaultInputStyle;
    };
    var getInputToRender = function () {
        switch (textInputType) {
            case 'textarea':
                if (nameProp && register) {
                    return (_jsx("textarea", __assign({ autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, maxLength: maxLength, rows: 4 }, register(nameProp), { className: getInputStyle(), defaultValue: '', onKeyDown: function (e) { }, style: {
                            backgroundColor: isAdminPortalField ? 'adminPortalBg' : '',
                        } }, restProps)));
                }
                else {
                    return (_jsx("textarea", __assign({ autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, rows: 4, maxLength: maxLength, className: getInputStyle(), defaultValue: value !== null && value !== void 0 ? value : '', style: {
                            backgroundColor: isAdminPortalField ? 'adminPortalBg' : '',
                        }, value: value }, restProps)));
                }
            case 'moneyInput':
                if (nameProp && register) {
                    return (_jsx(CurrencyInput, __assign({ id: "validation-example-2-field", allowDecimals: true, step: 10, autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, type: type, maxLength: maxLength, disableAbbreviations: true }, register(nameProp), { className: disabled
                            ? styles.disabledMoneyInputStyle
                            : error
                                ? styles.errorStyle
                                : styles.defaultMoneyInputStyle, style: prefixIcon || startIcon
                            ? { paddingRight: 38 }
                            : { paddingRight: 16 }, value: value, decimalSeparator: "." }, restProps)));
                }
                else {
                    return (_jsx(CurrencyInput, __assign({ id: "validation-example-2-field", allowDecimals: true, step: 10, autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, type: type, maxLength: maxLength, value: value !== null && value !== void 0 ? value : '', disableAbbreviations: true, className: disabled
                            ? styles.disabledMoneyInputStyle
                            : error
                                ? styles.errorStyle
                                : styles.defaultMoneyInputStyle, style: {
                            paddingRight: suffixIcon ? 38 : 16,
                            paddingLeft: prefixIcon || startIcon ? 20 : 16,
                        }, decimalSeparator: "." }, restProps)));
                }
            case 'input':
            default:
                if (nameProp && register) {
                    return (_jsx("input", __assign({ autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, type: type, maxLength: maxLength }, register(nameProp), { className: getInputStyle(), style: {
                            paddingRight: suffixIcon ? 38 : 16,
                            paddingLeft: prefixIcon ? 20 : startIcon ? 50 : 16,
                            backgroundColor: isAdminPortalField
                                ? 'adminPortalBg'
                                : color
                                    ? "var(--".concat(color, ")")
                                    : 'bg-uiBg',
                        }, onKeyDown: onKeyDown }, restProps)));
                }
                else {
                    return (_jsx("input", __assign({ autoComplete: "new-off", placeholder: placeholder, disabled: disabled || readonly, type: type, maxLength: maxLength, className: classNames(styles.getBorderClass(value, maxCharacters), getInputStyle()), value: value, style: {
                            paddingRight: suffixIcon ? 38 : 16,
                            paddingLeft: prefixIcon ? 20 : startIcon ? 50 : 16,
                            backgroundColor: color ? "var(--".concat(color, ")") : 'bg-uiBg',
                        }, onKeyDown: onKeyDown }, restProps)));
                }
        }
    };
    return (_jsx(_Fragment, { children: visible && (_jsxs("div", __assign({ className: className }, { children: [label && (_jsx("label", __assign({ htmlFor: nameProp, className: disabled
                        ? styles.disabledLabel
                        : isAdminPortalInput
                            ? styles.adminPortalLabel
                            : styles.label }, { children: label }))), subLabel && (_jsx("label", __assign({ htmlFor: nameProp, className: styles.subLabel }, { children: subLabel }))), hint && _jsx("label", __assign({ className: styles.hintStyle }, { children: hint })), _jsxs("div", __assign({ className: styles.inputWrapper }, { children: [getInputToRender(), _jsxs("div", __assign({ className: styles.iconWrapperLeft }, { children: [!!startIcon &&
                                    renderIcon(startIcon, "ml-4 h-5 w-5 text-".concat(startIconColor)), !!prefixIcon && (_jsx("span", __assign({ className: "text-".concat(disabled ? 'textLight' : 'textDark', " align-center items-center pl-1 font-semibold") }, { children: "R" })))] })), _jsx("div", __assign({ className: styles.iconWrapper, onClick: suffixIconAction }, { children: !!suffixIcon &&
                                renderIcon(suffixIcon, "h-5 w-5 text-".concat(sufficIconColor)) }))] })), _jsxs("span", __assign({ className: "text-errorMain text-xs" }, { children: [" ", error === null || error === void 0 ? void 0 : error.message, " "] })), !!maxCharacters && (_jsxs("p", __assign({ className: classNames('text-xs', value && (value === null || value === void 0 ? void 0 : value.toString().length) > maxCharacters
                        ? 'text-errorMain'
                        : 'text-infoDark') }, { children: [(value === null || value === void 0 ? void 0 : value.toString().length) || 0, "/", maxCharacters, " characters used"] })))] }))) }));
};
//# sourceMappingURL=form-input.js.map